import { observable } from 'mobx';
import moment from '@this/lib/moment';

export type KitElementResponseArgs = {
  id: number;
  name: string;
  started_at: string;
  ended_at: string;
};

export type KitElementArgs = {
  id: number;
  name: string;
  startedAt: moment.Moment;
  endedAt: moment.Moment;
};

export const convertKitElementResponseToArgs = (response: KitElementResponseArgs) => {
  const args: KitElementArgs = {
    id: response.id,
    name: response.name,
    startedAt: moment(response.started_at),
    endedAt: response.ended_at ? moment(response.ended_at) : moment(response.started_at).add(1, 'hour')
  };
  return args;
};

export default class KitElement {
  @observable id: number;
  @observable name: string;

  @observable
  startedAt: moment.Moment;

  @observable
  endedAt: moment.Moment;

  constructor(args: KitElementArgs) {
    this.id = args.id;
    this.name = args.name;
    this.startedAt = args.startedAt;
    this.endedAt = args.endedAt;
  }

  get type() {
    return 'kit';
  }

  get startDate() {
    return this.startedAt;
  }

  get endDate() {
    return this.endedAt;
  }

  get title() {
    return '新型コロナ検査キット';
  }

  get summary() {
    return '[新型コロナ検査キット]';
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
